/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {SignalAdminResourceApiBase, SignalAdminResourceModel} from '../../common/controller/signal-admin-resource-api';

export interface DataExportModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class DataExportApiService extends SignalAdminResourceApiBase<DataExportModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'dataexports');
  }

  copy(source: Pick<DataExportModel, 'id' | 'name'> & {description?: string}, newId: string): Observable<DataExportModel> {
    return this.client.request<DataExportModel>({
      method: 'POST',
      url: this.resourceUri(`dataexports/${encodeURIComponent(source.id)}/copy`),
      params: {
        dataExportId: newId,
        name: source.name,
        description: source.description
      }
    });
  }
}
